module.exports = __webpack_public_path__ + "img/canvas-bg5.982356a9.png";